import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPendingStatus = (pendingStatusId: number | undefined): Promise<IGetPendingStatus> => {
  return axiosDefaultApi.get(`/api/PendingStatus/GetPendingStatusViaID/${pendingStatusId}`);
};

type QueryFnType = typeof getPendingStatus;

type UseGetPendingStatusOptions = {
  pendingStatusId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPendingStatus = ({ pendingStatusId , config }: UseGetPendingStatusOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPendingStatus_${pendingStatusId}`],
    queryFn: () => getPendingStatus(pendingStatusId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Κατηγορίας Εκκρεμότητας.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};